import { render, staticRenderFns } from "./AuthChoose.vue?vue&type=template&id=056561fa&scoped=true"
import script from "./AuthChoose.vue?vue&type=script&lang=js"
export * from "./AuthChoose.vue?vue&type=script&lang=js"
import style0 from "./AuthChoose.vue?vue&type=style&index=0&id=056561fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056561fa",
  null
  
)

export default component.exports